var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _circle, _circle2, _path71, _path72, _path73, _path74, _path75, _path76, _path77;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 664 367",
    width: 664,
    height: 367,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 50.000,183.125 C 53.835,181.043 54.000,181.625 58.000,180.125",
    strokeWidth: 5.559,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 58.000,180.125 C 83.512,175.184 83.335,174.543 109.000,170.125",
    strokeWidth: 1.716,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 109.000,170.125 C 149.000,162.125 149.012,162.184 189.000,154.125",
    strokeWidth: 1.158,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 189.000,154.125 C 233.965,144.946 234.000,145.125 279.000,136.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 279.000,136.125 C 331.015,126.200 330.965,125.946 383.000,116.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 383.000,116.125 C 410.773,108.907 395.515,113.700 408.000,111.125",
    strokeWidth: 1.417,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 408.000,111.125 C 388.564,121.211 403.273,114.907 368.000,128.125",
    strokeWidth: 2.798,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 368.000,128.125 C 330.338,140.435 330.564,140.711 292.000,150.125",
    strokeWidth: 1.181,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 292.000,150.125 C 239.104,162.603 239.338,163.435 186.000,174.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 186.000,174.125 C 133.011,185.177 133.104,185.603 80.000,196.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 80.000,196.125 C 41.086,204.595 41.011,204.177 2.000,212.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 97.000,193.125 C 98.352,195.531 98.000,195.625 99.000,198.125",
    strokeWidth: 5.496,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 99.000,198.125 C 99.403,201.641 99.852,201.531 100.000,205.125",
    strokeWidth: 4.333,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 100.000,205.125 C 102.700,219.092 102.403,219.141 105.000,233.125",
    strokeWidth: 2.41,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 105.000,233.125 C 107.130,249.690 107.700,249.592 110.000,266.125",
    strokeWidth: 1.967,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 110.000,266.125 C 114.319,280.994 112.630,281.190 116.000,296.125",
    strokeWidth: 1.942,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 116.000,296.125 C 115.676,316.561 117.319,307.994 116.000,320.125",
    strokeWidth: 2.374,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 134.000,256.125 C 133.402,253.139 133.500,253.125 133.000,250.125",
    strokeWidth: 5.221,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 133.000,250.125 C 134.051,244.715 132.402,245.639 132.000,241.125",
    strokeWidth: 4.606,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 132.000,241.125 C 128.935,236.746 130.051,237.715 125.000,236.125",
    strokeWidth: 4.484,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 125.000,236.125 C 117.214,235.035 119.435,235.246 113.000,238.125",
    strokeWidth: 4.215,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 113.000,238.125 C 110.372,242.478 109.714,240.535 110.000,247.125",
    strokeWidth: 3.773,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 110.000,247.125 C 108.027,255.990 109.372,254.978 111.000,263.125",
    strokeWidth: 3.112,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 111.000,263.125 C 116.879,274.327 115.527,273.990 125.000,283.125",
    strokeWidth: 2.435,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 125.000,283.125 C 129.597,287.581 128.879,287.327 135.000,289.125",
    strokeWidth: 3.003,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 135.000,289.125 C 140.758,290.316 140.097,290.581 146.000,289.125",
    strokeWidth: 3.28,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 146.000,289.125 C 152.101,287.533 151.758,287.816 157.000,284.125",
    strokeWidth: 3.286,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 157.000,284.125 C 164.642,279.663 163.601,279.533 169.000,273.125",
    strokeWidth: 2.921,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 169.000,273.125 C 171.273,266.689 172.642,267.663 173.000,260.125",
    strokeWidth: 3.004,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 173.000,260.125 C 175.854,254.434 173.773,257.189 174.000,254.125",
    strokeWidth: 3.681,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 174.000,254.125 C 166.270,254.436 169.854,253.434 161.000,258.125",
    strokeWidth: 4.318,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 161.000,258.125 C 157.312,263.006 156.270,261.436 154.000,268.125",
    strokeWidth: 3.462,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 154.000,268.125 C 149.721,272.060 151.812,271.506 150.000,275.125",
    strokeWidth: 3.652,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 150.000,275.125 C 152.098,279.125 150.221,277.560 155.000,279.125",
    strokeWidth: 4.347,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 155.000,279.125 C 162.365,278.000 161.598,279.125 169.000,275.125",
    strokeWidth: 3.261,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 169.000,275.125 C 177.232,270.980 177.365,271.500 185.000,266.125",
    strokeWidth: 2.85,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 185.000,266.125 C 190.778,259.569 189.232,263.480 193.000,260.125",
    strokeWidth: 3.301,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 193.000,260.125 C 193.000,264.125 194.778,260.569 193.000,268.125",
    strokeWidth: 4.353,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 193.000,268.125 C 191.133,273.492 193.000,271.625 193.000,275.125",
    strokeWidth: 4.55,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 193.000,275.125 C 197.868,276.812 195.133,276.992 201.000,275.125",
    strokeWidth: 4.534,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 201.000,275.125 C 203.256,271.418 204.368,273.312 206.000,268.125",
    strokeWidth: 3.944,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 206.000,268.125 C 209.189,262.446 208.256,265.418 211.000,263.125",
    strokeWidth: 3.964,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 211.000,263.125 C 211.623,267.856 213.189,263.946 214.000,271.125",
    strokeWidth: 4.689,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 214.000,271.125 C 216.236,273.779 215.623,273.356 219.000,274.125",
    strokeWidth: 4.753,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 219.000,274.125 C 224.829,274.780 224.236,274.779 230.000,273.125",
    strokeWidth: 3.725,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 230.000,273.125 C 237.547,270.427 237.329,270.780 244.000,266.125",
    strokeWidth: 3.061,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 244.000,266.125 C 250.561,257.438 249.547,262.427 254.000,257.125",
    strokeWidth: 3.116,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 254.000,257.125 C 254.101,261.228 256.061,256.938 255.000,265.125",
    strokeWidth: 4.306,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 255.000,265.125 C 254.808,269.540 255.601,267.728 257.000,270.125",
    strokeWidth: 4.65,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 257.000,270.125 C 263.516,269.125 262.308,271.540 270.000,269.125",
    strokeWidth: 4.489,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 270.000,269.125 C 273.514,270.125 273.516,269.125 277.000,270.125",
    strokeWidth: 5.007,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 277.000,270.125 C 279.690,270.152 279.514,270.125 282.000,269.125",
    strokeWidth: 5.143,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 282.000,269.125 C 288.625,265.844 288.690,266.152 295.000,262.125",
    strokeWidth: 3.36,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M 295.000,262.125 C 307.707,256.628 306.625,255.344 318.000,248.125",
    strokeWidth: 2.434,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M 318.000,248.125 C 332.238,238.040 330.707,237.628 341.000,224.125",
    strokeWidth: 1.975,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M 341.000,224.125 C 357.423,196.268 357.738,197.540 369.000,167.125",
    strokeWidth: 1.298,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M 369.000,167.125 C 371.388,158.411 371.923,159.768 370.000,151.125",
    strokeWidth: 2.115,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M 370.000,151.125 C 368.180,146.428 369.388,147.911 365.000,146.125",
    strokeWidth: 3.144,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M 365.000,146.125 C 355.350,144.663 357.680,145.428 349.000,149.125",
    strokeWidth: 2.95,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M 349.000,149.125 C 335.140,158.685 336.850,157.663 328.000,172.125",
    strokeWidth: 2.265,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M 328.000,172.125 C 317.848,192.153 318.140,190.685 315.000,213.125",
    strokeWidth: 1.691,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M 315.000,213.125 C 311.663,234.444 312.348,232.653 317.000,253.125",
    strokeWidth: 1.681,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M 317.000,253.125 C 322.271,272.152 321.663,269.444 335.000,283.125",
    strokeWidth: 1.835,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M 335.000,283.125 C 353.987,296.575 351.271,297.152 375.000,303.125",
    strokeWidth: 1.625,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M 375.000,303.125 C 393.511,306.427 392.487,308.575 412.000,307.125",
    strokeWidth: 1.72,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M 412.000,307.125 C 422.554,308.029 420.011,307.427 428.000,305.125",
    strokeWidth: 2.437,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M 428.000,305.125 C 428.860,300.520 430.054,304.029 427.000,299.125",
    strokeWidth: 3.687,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M 427.000,299.125 C 423.397,298.488 424.860,297.520 420.000,299.125",
    strokeWidth: 3.842,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M 420.000,299.125 C 415.113,299.931 415.397,299.988 411.000,302.125",
    strokeWidth: 3.619,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M 411.000,302.125 C 404.312,305.520 407.613,303.931 405.000,307.125",
    strokeWidth: 4.207,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    cx: 342,
    cy: 191.125,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    cx: 351,
    cy: 176.125,
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M 494.000,156.125 C 490.337,157.298 490.500,157.625 487.000,159.125",
    strokeWidth: 4.636,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M 487.000,159.125 C 470.043,170.171 469.337,168.798 452.000,179.125",
    strokeWidth: 1.989,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M 452.000,179.125 C 403.051,202.235 403.543,203.171 354.000,225.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M 354.000,225.125 C 312.399,242.926 313.051,244.235 272.000,263.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M 272.000,263.125 C 234.651,282.509 234.399,281.926 198.000,303.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M 198.000,303.125 C 170.758,318.736 170.651,318.509 144.000,335.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M 144.000,335.125 C 130.851,343.419 130.758,343.236 118.000,352.125",
    strokeWidth: 1.572,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.27b323f249b6ac56e7510faa5da7442c.svg";
export { ForwardRef as ReactComponent };